// Tarih-aktif pencere <-> AntD RangePicker değeri dönüşümü. Wire format ISO
// string çifti; RangePicker Dayjs çifti taşır.

import dayjs, { type Dayjs } from 'dayjs';

export type RangeValue = [Dayjs | null, Dayjs | null] | null;

export function toRange(
  start: string | null | undefined,
  end: string | null | undefined,
): RangeValue {
  if (!start && !end) return null;
  return [start ? dayjs(start) : null, end ? dayjs(end) : null];
}

export function fromRange(range: RangeValue): { startDate: string | null; endDate: string | null } {
  const s = range?.[0] ?? null;
  const e = range?.[1] ?? null;
  return {
    startDate: s ? s.toISOString() : null,
    endDate: e ? e.toISOString() : null,
  };
}
